"use client";

import { Button } from "@/components/ui/button";

export default function ErrorPage({
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<div className="flex min-h-screen flex-col items-center justify-center px-6">
			<div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-indigo-500">
				<span className="font-sans text-2xl font-bold text-white">u</span>
			</div>
			<h1 className="mb-2 font-sans text-4xl font-bold tracking-tight text-foreground">
				Something went wrong
			</h1>
			<p className="mb-8 text-base text-muted-foreground">
				An unexpected error occurred. Try again or head back home.
			</p>
			<div className="flex gap-3">
				<Button
					onClick={reset}
					className="bg-indigo-500 font-mono text-sm text-white hover:bg-indigo-400"
				>
					Try again
				</Button>
				<a href="/">
					<Button variant="outline" className="font-mono text-sm">
						Back to home
					</Button>
				</a>
			</div>
		</div>
	);
}
